import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import {Duration} from "moment"
import {toMomentDate} from "../../gd/convert/moment-date"
import Reaction from "../reaction/reaction";
import ApiTaskMessage from "../../gd/api/task-message";
import Reactions from "../reaction/reactions";
import isSameValue from "../../gd/utils/misc/is-same-value"
import {TaskMessageCommunicationFlow, TaskMessageType} from "../../gd/const/task-messages/task-messages"

const debug = false
// const debug = 'TaskMessage'

export default class TaskMessage extends ModelEntity {

    type                    : number    // TaskMessageType

    fromUserId              : string
    editByUserId            : ID
    toUserId                : ID

    arUserReplyTimeMinutes? : number
    arUserReplyTime?        : Duration
    getBackTime?            : Duration

    dateCreated             : Moment
    momentCreated           : Moment
    scheduleDate?           : Moment
    editDate?               : Moment

    attachments             : any
    timeReportId            : ID | null

    message                 : string
    messageRTF              : any

    taskId                  : ID

    reactions               : Reactions

    communicationFlow       : TaskMessageCommunicationFlow    // gd.const.communicationFlow
    taskSystemStatusOld     : number
    taskSystemStatusNew     : number
    taskStatusId            : ID

    params                  : any       // params like deadline, estimate, emailNotifications etc.

    // set on a ticket customer's message only - they have no fromUserId (no
    // GD user account), crmContactId says which CRM contact sent it, see
    // docs/code/support-tickets-frontend.md's "source"
    source                  : {type: string, crmContactId: ID} | null

    // message render parameter
    render                  : any
    todoItem                : boolean = false

    constructor(data: any) {
        super(data.id, EntityType.TASK_MESSAGE)

        this.type                   = data.type ? data.type : data.messageType
        this.taskId                 = data.taskId

        this.reactions              = Reactions.initFromJson(data.reactions)

        this.fromUserId             = data.fromUserId ? data.fromUserId : data.userId
        this.editByUserId           = data.editByUserId
        // this.toUserId               = data.actionRequiredUserId ? data.actionRequiredUserId : data.toUserId
        this.toUserId               = this._initToUserIdValue(data)

        this.arUserReplyTimeMinutes = data.arUserReplyTime ? data.arUserReplyTime : data.arUserReplyTimeMinutes
        this.arUserReplyTime        = data.arUserReplyTimeMinutes ? moment.duration(data.arUserReplyTimeMinutes,'minutes') : undefined
        this.getBackTime            = data.getBackTime ? moment.duration(data.getBackTime,'minutes') : undefined

        this.dateCreated            = DatetimeUtils.dateToMoment(data.dateCreated ? data.dateCreated : data.momentCreated)
        this.momentCreated          = DatetimeUtils.datetimeToMoment(data.momentCreated ? data.momentCreated : data.dateCreated)
        this.scheduleDate           = data.scheduleDate ? DatetimeUtils.datetimeToMoment(data.scheduleDate) : undefined
        this.editDate               = data.editDate ? DatetimeUtils.datetimeToMoment(data.editDate) : undefined

        this.attachments            = data.attachments
        this.timeReportId           = data.timeReportId

        this.message                = data.message
        this.messageRTF             = data.messageRtf ? data.messageRtf : data.messageRTF

        this.communicationFlow      = data.communicationFlow
        this.taskSystemStatusOld    = data.taskSystemStatusOld
        this.taskSystemStatusNew    = data.taskSystemStatusNew
        this.taskStatusId           = data.taskStatusId

        this.params                 = data.params
        this.source                 = data.source || null

        // message render parameter
        this.render             = {
            arChanged       : [
                    gd.const.communicationFlow.GET_BACK,
                    gd.const.communicationFlow.SWITCH,
                    gd.const.communicationFlow.INTERRUPT
                ].includes(this.communicationFlow) ||
                TaskMessageType.AR_CHANGE === this.type,
            statusChanged   : !!this.taskStatusId
        }

        return this
    }

    get isSystem():boolean {
        return this.type === TaskMessageType.PRIORITY ? !this.communicationFlow : this.type > 9
    }

    get isStatusUpdateRequest():boolean {
        return this.type === TaskMessageType.STATUS_UPDATE_REQUEST
    }

    _initToUserIdValue(data:any) {

        if (this.isStatusUpdateRequest) {
            return data.params?.userId
        }

        return data.actionRequiredUserId ? data.actionRequiredUserId : data.toUserId
    }

    toggleReaction(reactionType: number) {

        // no await here ! we save change but rerender instanlty

        if (this.reactions.isMyReaction(reactionType)) {
            ApiTaskMessage.deleteReaction(this.taskId, this.id, reactionType).promise()
            this.reactions.removeMyReaction(reactionType)
        } else {
            ApiTaskMessage.addReaction(this.taskId, this.id, reactionType).promise()
            this.reactions.addMyReaction(reactionType)
        }

    }

    applyDelta(data:any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta", "key=", key, "value=", value)

            const updateParamsNames = []
            switch (key) {
                case 'userId'                       : updateParamsNames.push('fromUserId'); break
                case 'messageType'                  : updateParamsNames.push('type'); break
                case 'arUserReplyTime'              : updateParamsNames.push('arUserReplyTimeMinutes'); break
                case 'actionRequiredUserId'         : updateParamsNames.push('toUserId'); break
                case 'messageRtf'                   : updateParamsNames.push('messageRTF'); break
                default                             : updateParamsNames.push(key)
            }

            debug && console.log(debug, "applyDelta updateParamsNames=", updateParamsNames)
            _.map(updateParamsNames, (paramName)=>{
                switch (paramName) {

                    case 'reactions':
                        this.reactions = Reactions.initFromJson(value)
                        isChanged = true
                        break

                    case 'arUserReplyTime'          :
                        if (!isSameValue(this, paramName, value)) {
                            this.arUserReplyTimeMinutes = value
                            this.arUserReplyTime        = value ? moment.duration(value,'minutes') : undefined
                            isChanged = true
                        }
                        break

                    case 'getBackTime'              :
                        if (!isSameValue(this, paramName, value)) {
                            this.getBackTime = value ? moment.duration(value,'minutes') : undefined
                            isChanged = true
                        }
                        break

                    case 'momentCreated'            :
                        if (!isSameValue(this, paramName, value)) {
                            this.dateCreated    = DatetimeUtils.dateToMoment(value)
                            this.momentCreated  = DatetimeUtils.datetimeToMoment(value)
                            isChanged = true
                        }
                        break

                    case 'dateCreated'              :
                    case 'scheduleDate'             :
                    case 'editDate'                 :
                        if (!isSameValue(this, paramName, value)) {
                            // @ts-ignore
                            this[paramName] = toMomentDate(value)
                            isChanged = true
                        }
                        break

                    default                         :
                        debug && console.log(debug, "applyDelta paramName=", paramName, !isSameValue(this, paramName, value), _.get(this,paramName), value)

                        if (!isSameValue(this, paramName, value)) {
                            // @ts-ignore
                            this[paramName] = value;
                            isChanged = true
                        }
                }
            })
        });

        debug && console.log(debug, "applyDelta isChanged", isChanged, this)

        return isChanged
    }

    toJSON() {
        return {
            id                     : this.id,
            type                   : this.type,

            fromUserId             : this.fromUserId,
            editByUserId           : this.editByUserId,
            toUserId               : this.toUserId,

            arUserReplyTimeMinutes : this.arUserReplyTimeMinutes,
            getBackTime            : this.getBackTime ? this.getBackTime.toJSON() : undefined,

            dateCreated            : DatetimeUtils.momentToUTCISODatetime(this.dateCreated),
            scheduleDate           : this.scheduleDate ? DatetimeUtils.momentToDate(this.scheduleDate) : undefined,
            editDate               : this.editDate ? DatetimeUtils.momentToUTCISODatetime(this.editDate) : undefined,

            attachments            : this.attachments,
            timeReportId           : this.timeReportId,

            message                : this.message,
            messageRTF             : this.messageRTF,

            communicationFlow      : this.communicationFlow,
            taskSystemStatusOld    : this.taskSystemStatusOld,
            taskSystemStatusNew    : this.taskSystemStatusNew,
            taskStatusId           : this.taskStatusId,

            params                 : this.params,
        }
    }
}
